import {
  Blockquote,
  Bold,
  BulletList,
  CodeInline,
  Color,
  ColorHighlighter,
  Image,
  InlineEditorBulletList,
  InlineEditorListItem,
  InlineEditorOrderedList,
  InlineEditorParagraph,
  Italic,
  Link,
  ListItem,
  OrderedList,
  SelectionToolbar,
  Strikethrough,
  TypographyInputRules,
  Underline,
} from '@lyearn/lygo-blocks';

export const TASK_INSTRUCTION_EDITOR_EXTENSIONS = [
  Bold,
  Italic,
  Underline,
  CodeInline,
  Strikethrough,
  Link,
  SelectionToolbar,
  Color,
  TypographyInputRules,
  ColorHighlighter,
  BulletList,
  Blockquote,
  OrderedList,
  ListItem,
  InlineEditorBulletList,
  InlineEditorOrderedList,
  InlineEditorParagraph,
  InlineEditorListItem,
  Image,
];
